<template>
  <div class="home-page" :class="{ 'is-iframe': isInIframe }">
    <!-- 在iframe中，只显示router-view，不显示任何布局元素 -->
    <div v-if="isInIframe" style="flex: 1;">
      <router-view></router-view>
    </div>
    <!-- 不在iframe中时，显示正常布局 -->
    <template v-else>
      <!-- 将header移到最顶部，跨越整个页面宽度 -->
      <main-header v-show="isLogin" />
      <!-- 当未登录时，直接显示router-view，不包含在el-container中 -->
      <div v-if="!isLogin" style="flex: 1;">
        <router-view></router-view>
      </div>
      <!-- 当已登录时，显示正常的布局 -->
      <el-container v-else class="main-container">
        <side-menu />
        <el-main class="main_area" style="margin-left: 11.6vw;">
          <!-- 移除这里的main-header，因为已经移到顶部 -->
          <keep-alive :include="cachedPages" :max="max">
            <router-view></router-view>
          </keep-alive>
          <el-footer>
            <p class="font_14_gray copyright">版权所有：深圳市泛亚人力资源股份有限公司</p>
            <p
              class="font_14_gray copyright"
            >Copyright 2004-{{new Date().getFullYear()}} fairhr All rights reserved.粤ICP备17155517号-1</p>
          </el-footer>
        </el-main>
      </el-container>
    </template>
  </div>
</template>

<script>
import SideMenu from "@/components/SideMenu.vue";
import MainHeader from "@/components/header/index.vue";
import { getToken } from "@/js/tool.js";
import { Get } from "@/js/http.js";

export default {
  data() {
    return {
      max: 1,
      // 缓存列表页，需要缓存页面必须声明export default中的name，其值必须包含在此数组中
      // cachedPages: [
      //   "EmployeeInfo",
      //   "EmployeeContract",
      //   "SocialSecurity",
      //   "SalaryBatches",
      //   "SalaryDetails"
      // ],
      // currentRouter:'/'
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    cachedPages() {
      return this.$store.state.cachedPages;
    },
    isInIframe() {
      try {
        return window.parent !== window;
      } catch (e) {
        return true;
      }
    }
  },
  watch: {
    // $route: function(to) {
    //   this.currentRouter = to.path;
    // }
  },
  methods: {
    // 关闭或刷新页面
    beforeunloadFn() {},
    // 获取未读通知条数
    getUnreadMessage() {
      Get("api/v1.0/global/messages/unread")
        .then(res => {
          localStorage.setItem("unreadNum", res.data); // local存储未读信息数量
          this.$store.commit("unreadMessage", res.data); // 开启指定页面缓存
        })
        .catch(() => {});
    },
    // 绑定窗口缩放事件
    ifResize() {
      window.addEventListener("resize", this.resize);
    },
    resize() {
      this.$store.commit("clientWidth", document.body.clientWidth);
    }
  },
  beforeMount() {
    // this.currentRouter = this.$route.path;
  },
  mounted() {
    if (!getToken()) {
      this.$router.replace({ name: "Login" });
    } else {
      this.getUnreadMessage();
    }

    this.ifResize();
    // window.addEventListener("load", e => this.beforeunloadFn(e));
  },
  beforeDestroy() {
    // 解除事件
    window.removeEventListener('resize', this.resize)
  },
  components: {
    SideMenu,
    MainHeader
  }
};
</script>

<style lang="scss">
.home-page {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.el-header {
  padding-top: 18px;
  margin-bottom: 30px;
}
.main_area {
  padding-top: 24px;
  overflow-x: auto;
  min-height: calc(100vh - 70px);
}
.el-main {
  padding: 0;
  overflow-x: auto;
  min-height: calc(100vh - 70px);
}
.main_area {
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-x: auto;
}

.copyright {
  line-height: 28px;
  text-align: center;
}

.main-container {
  flex: 1;
  background-color: #efeff3;
  margin-top: 70px;
}

.home-page.is-iframe .main-container {
  margin-top: 0;
}
</style>
